import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { removeTemperatureSetting } from './utils';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { unpack_validation } from 'z3k-parser/validation/types';
import { BoilerCascade, HeatingCircuit } from 'z3k-config';
import { useBox } from 'shared/hooks/utils';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
export function HeatingModesList() {
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const { addIdToBlacklist, device_spec } = useContext(Z3KSettings);
    const configBox = useBox(config);
    const onDeleteMode = useCallback((mode, new_list) => {
        addIdToBlacklist(mode.id);
        const new_config = mode.heating_zones.reduce((current_config, { temperature_setting }) => removeTemperatureSetting(current_config, temperature_setting, addIdToBlacklist), configBox.current);
        replace_config({
            ...findAndChangeLinks(new_config, mode.id),
            heating_modes: new_list,
        });
    }, [addIdToBlacklist, replace_config]);
    const addBoiler = useCallback(() => {
        replace_config(HeatingMode.get.add(configBox.current, {
            name: 'Котловой режим',
            heating_zones: [],
            setting_register: 0,
            water_sensor: null,
            start_reserve_delay: 10,
            max_modulation_level: 0,
            force_boiler_mode: true,
        })[1]);
    }, [replace_config]);
    const heating_circuits = HeatingCircuit.get.all(config);
    const boiler_cascades = BoilerCascade.get.all(config);
    const filter_consumer_modes = useCallback((mode) => HeatingMode.filterConsumerMode(mode, heating_circuits, boiler_cascades), [heating_circuits, boiler_cascades]);
    const filter_boiler_modes = useCallback((mode) => HeatingMode.filterBoilerMode(mode, heating_circuits, boiler_cascades), [heating_circuits, boiler_cascades]);
    const childrenItem = (selected_item_id) => {
        return (_jsxs(_Fragment, { children: [_jsx(DragDropDrawer, { z3k_name: "heating_modes", name: RouteNaming[Z3kSecondRoutes.heating_modes], help_id: "heating_modes", enableDnd: true, item_url: Z3kSecondRoutes.heating_modes, onDelete: onDeleteMode, objectFilter: filter_consumer_modes, selected_item_id: selected_item_id }), device_spec.heating.has_heating &&
                    device_spec.heating.has_extended_heating.show_boiler_modes && (_jsx(ErrorBoundary, { children: _jsx(DragDropDrawer, { z3k_name: "heating_modes", name: RouteNaming[Z3kSecondRoutes.boiler_modes], help_id: "heating_modes_boiler_mode", enableDnd: true, item_url: Z3kSecondRoutes.boiler_modes, onDelete: onDeleteMode, onAddClick: addBoiler, objectFilter: filter_boiler_modes, selected_item_id: selected_item_id }) }))] }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
HeatingModesList.isError = (validation_result) => !!unpack_validation(validation_result, 'heating_modes');
HeatingModesList.isWarning = HeatingModesList.isError;
HeatingModesList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => device_spec.heating.has_heating && !is_climatic;
